<script setup lang="ts">
  /**
   * Page section — 03-components/12d-page-header · OSCloud DS 1.1.34
   */
</script>

<template>
  <div class="page-section">
    <slot />
  </div>
</template>

<style scoped lang="scss">
  .page-section {
    margin-bottom: var(--bf-sp-4);

    &:last-child {
      margin-bottom: 0;
    }
  }
</style>
